import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { journeysListEntryPoint } from '@jira/spa-apps__servicedesk-journeys-list/src/JourneysListPage.entrypoint.tsx';
import { journeysHorizontalNavEntryPoint } from '@jira/navigation-apps__horizontal-nav-jsm-journeys/JourneysHorizontalNav.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { journeysListRoute } from '@jira/router-routes__journeys-routes/src/journeysListRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ProjectIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/project-app.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const journeysListPageEntryPoint = createPageEntryPoint({
	main: journeysListEntryPoint,
	horizontalNavigation: journeysHorizontalNavEntryPoint,
});

const notFoundPageEntryPoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

export const journeysListRouteEntry: Route = createEntry(journeysListRoute, () => ({
	group: 'servicedesk',
	ufoName: 'jsm.journeys-list',
	// eslint-disable-next-line no-restricted-syntax
	component: () => null,

	navigation: {
		menuId: MenuIdProjects,
	},

	layout: serviceProjectLayout,

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getConsolidationStateResource(),
	],

	entryPoint: () =>
		fg('jsm-active-journeys-table-m0') ? journeysListPageEntryPoint : notFoundPageEntryPoint,

	skeleton: ProjectIssueNavigatorSkeleton,

	meta: {
		reporting: {
			id: 'journeys-list',
			packageName: toPackageName(APP_NAMES.JOURNEYS),
			teamName: 'JSM Grape Soju',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
